import { useEffect } from 'react';
import { Layout } from '@/components/layout/Layout';

const CHATBOTTIA_SCRIPT_ID = 'chatbottia-convocore-widget';
const CHATBOTTIA_SCRIPT_SRC = 'https://cdn.convocore.ai/vg_live_build/vg_bundle.js';

export default function ChatbottiaTestPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Page de test Chatbottia | Pulsia';

    let robotsMeta = document.querySelector('meta[name="robots"]');
    const previousRobotsContent = robotsMeta?.getAttribute('content') ?? null;

    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'noindex,nofollow,noarchive');

    window.VG_CONFIG = {
      ID: 'DCu9tnImXX3mCi2nTxKv',
      region: 'eu',
      render: 'bottom-right',
      stylesheets: [
        'https://cdn.convocore.ai/vg_live_build/styles.css',
      ],
    };

    if (!document.getElementById(CHATBOTTIA_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = CHATBOTTIA_SCRIPT_ID;
      script.src = CHATBOTTIA_SCRIPT_SRC;
      script.defer = true;
      document.body.appendChild(script);
    }

    return () => {
      document.title = previousTitle;

      if (robotsMeta) {
        if (previousRobotsContent === null) {
          robotsMeta.remove();
        } else {
          robotsMeta.setAttribute('content', previousRobotsContent);
        }
      }
    };
  }, []);

  return (
    <Layout>
      <section className="relative flex min-h-screen items-center overflow-hidden pt-28">
        <div className="absolute inset-0 bg-gradient-hero" />
        <div className="hero-glow" />
        <div className="hero-glow-bottom" />
        <div className="absolute inset-0 bg-grid-pattern opacity-30" />

        <div className="section-container relative z-10 w-full py-20 text-center">
          <div className="mx-auto max-w-5xl">
            <span className="section-label mb-6 inline-flex">
              Acces client prive
            </span>

            <div className="gradient-border rounded-2xl bg-card/55 px-5 py-12 shadow-lg backdrop-blur-md sm:px-8 sm:py-16 lg:px-14">
              <p className="mb-5 text-sm font-semibold uppercase tracking-[0.28em] text-primary">
                Page de test Chatbottia
              </p>
              <h1 className="font-display text-4xl font-bold leading-tight text-foreground sm:text-5xl lg:text-6xl">
                Vous etes sur la page de test de votre agent{' '}
                <span className="gradient-text">Chatbot IA</span>.
              </h1>
              <p className="mx-auto mt-8 max-w-3xl text-xl leading-relaxed text-muted-foreground sm:text-2xl">
                Cliquez sur la bulle en bas a droite pour discuter avec votre
                agent en cours de developpement par l&apos;agence Pulsia.
              </p>
            </div>
          </div>
        </div>

        <div
          id="VG_OVERLAY_CONTAINER"
          aria-hidden="true"
          style={{ width: 0, height: 0 }}
        />
      </section>
    </Layout>
  );
}
